export const colors = {
  "--primary": process.env.NEXT_PUBLIC_PRIMARY || "#BED643",
  "--primary-100": process.env.NEXT_PUBLIC_PRIMARY_100 || "#BED64333",
  "--primary-200": process.env.NEXT_PUBLIC_PRIMARY_200 || "FFFF0098",

  

  "--text-primary": process.env.NEXT_PUBLIC_TEXT_PRIMARY || "#131313",
  "--text-secondary": process.env.NEXT_PUBLIC_TEXT_SECONDARY || "#989898",

  "--bg-secondary": process.env.NEXT_PUBLIC_BG_SECONDARY || "#FBFBFB",

  "--icon": process.env.NEXT_PUBLIC_BG_ICON || "#363435",
  "--icon-100": process.env.NEXT_PUBLIC_BG_ICON_100 || "#3634351A",

  "--star": process.env.NEXT_PUBLIC_STAR || "#E6A733",

  "--black": process.env.NEXT_PUBLIC_BLACK || "#000000",
  "--black-100": process.env.NEXT_PUBLIC_BLACK_100 || "#131313B2",
  "--black-200": process.env.NEXT_PUBLIC_BLACK_100 || "#000000B2",

  "--white": process.env.NEXT_PUBLIC_WHITE || "#FFFFFF",
  "--white-100": process.env.NEXT_PUBLIC_WHITE_100 || "#FCFCFC",
  "--white-200": process.env.NEXT_PUBLIC_WHITE_200 || "#FFFFFF1A",

  "--gray-100": process.env.NEXT_PUBLIC_GRAY_100 || "#F0F0F0",
  "--gray-200": process.env.NEXT_PUBLIC_GRAY_200 || "#000000B3",
  "--gray-300": process.env.NEXT_PUBLIC_GRAY_300 || "#EDEDED",
  "--gray-400": process.env.NEXT_PUBLIC_GRAY_400 || "#13131380",
  "--gray-900": process.env.NEXT_PUBLIC_GRAY_900 || "#090909",

  "--close-btn": process.env.NEXT_PUBLIC_CLOSE_BTN || "#FF3B30",

  /* Shadow Variables */
  "--shadow-01": process.env.NEXT_PUBLIC_SHADOW_01 || "#00000026",
  "--shadow-02": process.env.NEXT_PUBLIC_SHADOW_02 || "#0000000F",


  // font variables
  "--font-family-1": process.env.NEXT_PUBLIC_FONT_1 || '"Mukta", sans-serif',
  "--font-family-2":process.env.NEXT_PUBLIC_FONT_2 || '"Mukta", sans-serif;',
};


